import { inOpenlegal, inOpensalud360 } from '@/constants/platformNames'
import { PATIENT_ROLE, CENTER_ROLE, PROFESSIONAL_ROLE } from '@/constants/roles'
import AccountRepository from '@/repositories/AccountRepository'

export default {
    methods: {
			async defaultLoginCallback (loginInfo = null) {
				loginInfo = loginInfo || this.$store.state.session.loginInfo
				if (!loginInfo) { this.goLogin() }
				await this.$store.dispatch('session/create', { token: loginInfo.apiToken, loginInfo: loginInfo, reload: false })
				if (loginInfo.user.roles && loginInfo.user.roles.includes(PATIENT_ROLE) && !inOpenlegal()) {
					if (loginInfo.user && inOpensalud360() && !loginInfo.user.companyCode) {
						await this.$router.push('/error/unauthorized/360')
					} else {
						if ((this.$route.query.returnUrl || this.$route.query.ReturnUrl) && loginInfo.returnUrl && loginInfo.ssoUri) {
							window.location.href = loginInfo.ssoUri
						} else {
							await this.$router.push('/patient')
						}
					}
				} else {
					window.location.href = loginInfo.ssoUri
				}
			},
      goLogin () {
        if (this.$route.query.returnUrl || this.$route.query.ReturnUrl) {
          this.$router.push({path: '/inicio-sesion', query: {returnUrl: this.$route.query.returnUrl || this.$route.query.ReturnUrl}})
        } else {
          this.$router.push('/inicio-sesion')
        }
      },
      logOff (redirect = true) {
        this.$store.dispatch('session/remove')
        if (redirect) {
          this.$router.push('/')
        }
      },
      goProfile () {
        const profilePath = 'profile'
        switch (this.$store.state.session.user.userType) {
          case PATIENT_ROLE:
            this.$helpers.goToPatientWebApp(`${profilePath}`, this.$apiToken)
            break
          case PROFESSIONAL_ROLE:
            this.$helpers.goToWebApp(`/HomeProfessional/#/${profilePath}`)
            break
          case CENTER_ROLE:
            this.$helpers.goToWebApp(`/HomeCenter/#/${profilePath}`)
            break
        }
      },
      goToSessionRoot () {
        switch (this.$store.state.session.user.userType) {
          case PATIENT_ROLE:
            this.$router.push('/patient')
            break
          case PROFESSIONAL_ROLE:
            this.$helpers.goToWebApp(`/HomeProfessional/#/`)
            break
          case CENTER_ROLE:
            this.$helpers.goToWebApp(`/HomeCenter/#/`)
            break
        }
      },
      goHealthData () {
        this.$helpers.goToPatientWebApp('history', this.$apiToken)
      },
      goAppointments () {
        this.$helpers.goToPatientWebApp('appointments', this.$apiToken)
      },
      redirectIfAuthenticated (forceAnyRedirect = false) {
				// Avoid redirecting to the same page
        const token = this.$apiToken
        if (!token) {
          this.$store.dispatch('session/remove')
        } else if (this.$store.getters['session/userIsPatient']) {
          this.$router.push('/patient')
        } else if (this.$store.getters['session/userIsProfessional']) {
          this.$helpers.goToProfessionalWebApp('appointments', token)
        } else if (this.$store.getters['session/userIsCenter']) {
          this.$helpers.goToCenterWebApp('appointments', token)
        } else if (this.$store.getters.userIsAdmin) {
          this.$helpers.goToAdminWebApp('', token)
        } else if (forceAnyRedirect) {
          this.$router.push('/')
        } else {
          return
        }
      },
      async changeUser (patientId) {
        AccountRepository.loginAssociatedPatient(patientId).then(async (response) => {
          this.logOff(false)
          const responseData = response.data || (response.response ? response.response.data : null)
          const token = responseData.apiToken
          this.loginInfo = responseData
          this.$store.dispatch('session/set', responseData)
          await this.$store.dispatch('session/create', { token: token, loginInfo: responseData, reload: false })
					if (!(await this.processRequiredFields(responseData.user, responseData.requiredFields, token))) {
						window.location.reload()
					}
        })
      },
			async processRequiredFields (user, requiredFields, token) {
				if (!requiredFields || requiredFields.length === 0) {
					return false
				}
				this.$store.commit('session/setRequiredLoginFields',requiredFields)
				this.$store.commit('session/setUser', user)
				await this.$router.push({ path: '/cuenta/actualizar-datos', query: { token } })
				return true
			}
    }
  }


// WEBPACK FOOTER //
// ./src/mixins/account.mixin.js